module.exports = __webpack_public_path__ + "assets/pdf/E10-en-correcting-urban-bias.6635db1c.pdf";